{
	"backLinkTitle": "Volver a Gestionar declaraciones",
	"invoicedQuantity": "Cantidad facturada",
	"remainingForDeclarationCreation": "Restante para la creación de la declaración",
	"nonTransferableAmount": "Monto no asignable",
	"btnCreateDeclaration": "+ Crear declaración",
	"errorMessage": "No se pudieron cargar los detalles del material"
}
